import React, { useContext, useState } from "react";
import {
  Card,
  Form,
  FormLayout,
  TextField,
  Button,
  Select,
  InlineStack,
  Box,
  Thumbnail,
  DropZone,
} from "@shopify/polaris";
import { ToastContext } from "../../global-contexts/Toast";
import { ValidateSupportTickets } from "../../validators/SupportTickets";

const SupportTicketForm = ({ onSubmit, editable = true, handleFileUpload }) => {
  const [subject, setSubject] = useState("");
  const [query, setQuery] = useState("");
  const [priority, setPriority] = useState("medium");
  const [contactNumber, setContactNumber] = useState("");
  const [contactName, setContactName] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [attachment, setAttachment] = useState(null);
  const { setToast } = useContext(ToastContext);

  const resetState = () => {
    setSubject("");
    setQuery("");
    setPriority("medium");
    setContactName("");
    setContactNumber("");
    setAttachment(null);
  };
  const handleAttachmentDrop = (file) => {
    if (typeof file === "string") {
      setAttachment(file);
    } else {
      setAttachment(file[0]);
    }
  };

  const handleAttachmentRemove = () => {
    setAttachment(null);
  };
  const handleSubmit = async () => {
    setIsSubmitting(true);
    let attachmentUrl = "";
    try {
      if (attachment) {
        if (typeof attachment === "string") {
          attachmentUrl = attachment;
        } else if (attachment) {
          attachmentUrl = await handleFileUpload(attachment);
        }
      }
    } catch (e) {
      setToast({
        error: true,
        message: "Failed to upload logo",
        open: true,
      });
    }
    const payload = {
      subject,
      query,
      priority,
      contactName,
      contactNumber,
      attachment: attachmentUrl,
    };

    const validationError = ValidateSupportTickets({ ticket: payload });
    if (validationError) {
      setToast({
        message: validationError.error,
        error: true,
        open: true,
      });
      setIsSubmitting(false);
      return;
    }
    try {
      const data = await onSubmit(payload);
      setToast({
        message: data.message,
        error: false,
        open: true,
      });
      resetState();
    } catch (error) {
      setToast({
        message: error.message,
        error: true,
        open: true,
      });
      console.error("Submission failed", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const attachmentHint = !attachment && (
    <DropZone.FileUpload
      actionHint={<>Supported file formats: JPEG, JPG, PNG</>}
    />
  );

  return (
    <Form onSubmit={handleSubmit}>
      <div style={{ minWidth: "350px", maxWidth: "350px" }}>
        <Card title="Ticket Details" sectioned>
          <FormLayout>
            <TextField
              label="Contact Number"
              value={contactNumber}
              onChange={(value) => setContactNumber(value)}
              disabled={isSubmitting || !editable}
              type="number"
            />
            <TextField
              label="Contact Name"
              value={contactName}
              onChange={(value) => setContactName(value)}
              multiline
              required
              disabled={isSubmitting || !editable}
            />
            <TextField
              label="Subject"
              value={subject}
              onChange={(value) => setSubject(value)}
              required
              disabled={isSubmitting || !editable}
            />
            <TextField
              label="Description"
              value={query}
              onChange={(value) => setQuery(value)}
              required
              disabled={isSubmitting || !editable}
              multiline={4}
            />

            <Select
              label="Priority"
              options={[
                { label: "Low", value: "low" },
                { label: "Medium", value: "medium" },
                { label: "High", value: "high" },
                { label: "Urgent", value: "urgent" },
              ]}
              value={priority}
              onChange={(value) => setPriority(value)}
              disabled={isSubmitting || !editable}
            />
            <Box>
              <DropZone
                labelAction={"Drop an image"}
                // overlayText=""
                label="Attachment"
                accept="image/*"
                type="image"
                onDrop={handleAttachmentDrop}
                allowMultiple={false}
                disabled={!editable}
              >
                {attachmentHint}
                {attachment ? (
                  typeof attachment === "string" ? (
                    <Box>
                      <Thumbnail source={attachment} alt="Logo" size="large" />
                      <Button
                        disabled={!editable}
                        onClick={handleAttachmentRemove}
                      >
                        Remove
                      </Button>
                    </Box>
                  ) : (
                    <Box>
                      <Thumbnail
                        source={URL.createObjectURL(attachment)}
                        alt="Cover Photo"
                        size="small"
                      />
                      <Button
                        disabled={!editable}
                        onClick={(e) => {
                          e.stopPropagation();
                          handleAttachmentRemove(e);
                        }}
                      >
                        Remove
                      </Button>
                    </Box>
                  )
                ) : (
                  <DropZone.FileUpload />
                )}
              </DropZone>
            </Box>
          </FormLayout>
        </Card>
      </div>
      <br />

      <InlineStack align="center">
        <Button
          type="submit"
          loading={isSubmitting}
          variant="primary"
          onClick={() => {
            handleSubmit();
          }}
          disabled={isSubmitting}
        >
          Submit Ticket
        </Button>
      </InlineStack>
    </Form>
  );
};

export default SupportTicketForm;
